// crewbit-admin/src/components/schedule/DayGrid.tsx
//
// Schedule Module Phase C C1.5 — Day grid orchestrator. The ONE allowed switch
// in the canvas family per §0.10: layoutMode ('single-resource' | 'staff-columns').
// Body parallel to mobile crewbit-mobile/components/schedule/DayGrid.tsx
// modulo runtime per feedback_admin_pair_must_match_mobile_body.md.
//
// Spec: docs/references/schedule/SCHEDULE_MODULE_SPEC_v1.md §C.6 + §0.10.

import type { ScheduleEntry } from '../../types/schedule';
import type { DayLayoutMode } from '../../lib/scheduleLayout';
import { DaySingleColumn } from './DaySingleColumn';
import { DayStaffColumns } from './DayStaffColumns';
import type { ResourceColumnOperator } from './ResourceColumn';

export interface DayGridProps {
  date: string;
  layoutMode: DayLayoutMode;
  entries: ScheduleEntry[];
  travelBufferMinutes: number;
  operators?: ResourceColumnOperator[];
  onEntryTap: (entryId: string) => void;
  onEntryLongPress?: (entryId: string) => void;
  onResourceDrop?: (droppedEntryId: string, newResourceId: string) => void;
  showTravelSlivers?: boolean;
  industryAccent?: string;
  dayStartHour?: number;
  dayEndHour?: number;
}

export function DayGrid({
  date,
  layoutMode,
  entries,
  travelBufferMinutes,
  operators,
  onEntryTap,
  onEntryLongPress,
  onResourceDrop,
  showTravelSlivers,
  industryAccent,
  dayStartHour,
  dayEndHour,
}: DayGridProps) {
  if (layoutMode === 'staff-columns' && operators && operators.length > 0) {
    return (
      <DayStaffColumns
        operators={operators}
        entries={entries}
        travelBufferMinutes={travelBufferMinutes}
        onEntryTap={onEntryTap}
        onEntryLongPress={onEntryLongPress}
        onResourceDrop={onResourceDrop}
        showTravelSlivers={showTravelSlivers}
        industryAccent={industryAccent}
      />
    );
  }

  return (
    <DaySingleColumn
      date={date}
      entries={entries}
      travelBufferMinutes={travelBufferMinutes}
      onEntryTap={onEntryTap}
      onEntryLongPress={onEntryLongPress}
      showTravelSlivers={showTravelSlivers}
      industryAccent={industryAccent}
      dayStartHour={dayStartHour}
      dayEndHour={dayEndHour}
    />
  );
}
